import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        font-family: 'Open Sans', sans-serif;
        
    }

    body {
        background-color: #1e192c;
        color: #ffff;
        overflow-x: hidden;
    }
`